export const WEB_TO_APP_LINK = 'https://abr.ge/umbdfz';
//에어브릿지 web-to-app 링크
